import React from 'react'

export default function TeamMember({ team }) {
    const { name, avatar } = team || {}
    return (
        <div className="checkbox-container">
            <img src={require(`../assets/${avatar?.replace("/images/", "")}`)} alt={name} className="team-avater" />
            <p className="label">{name}</p>
        </div>
    )
}
